document.addEventListener("DOMContentLoaded", () => {
    if (!customElements.get("index-image-swiper ")) {
        class IndexImageSwiper extends HTMLElement {
            constructor() {
                super();
                this.container = this.querySelector(".index-image-swiper");
                this.swiper_obj = this.querySelector(".swiper");
                this.swiper = null;
            }
            connectedCallback() {
                this.detectObserver();
            }
            detectObserver() {
                let height = window.innerHeight / 2;
                if (this.container) {
                    const resizeObserver = new IntersectionObserver(
                        ([entry]) => {
                            if (entry.isIntersecting) {
                                this.initSwiper();
                                resizeObserver.disconnect();
                            }
                        },
                        { threshold: 0, rootMargin: `${height}px 0px 0px 0px` }
                    );
                    resizeObserver.observe(this.container);
                }
            }
            initSwiper() {
                if (!this.swiper_obj) return;
                const pagination = this.querySelector(".swiper-pagination");
                const swiper_auto = this.getAttribute("data-swiper_auto") == 'true' ? true : false
                const swiper_auto_time = this.getAttribute("data-swiper_auto_time") * 1
                const loop = this.getAttribute("data-swiper_loop") == 'true' ? true : false
                let autoplay = false
                if (swiper_auto) {
                    autoplay = {
                        delay: swiper_auto_time,
                        stopOnLastSlide: false,
                        disableOnInteraction: true,
                    }
                }
                this.swiper = new Swiper(this.swiper_obj, {
                    grabCursor: true,
                    centeredSlides: true,
                    slidesPerView: 1.25,
                    simulateTouch: true,
                    spaceBetween: 20,
                    autoplay: autoplay,
                    loop: loop,
                    pagination: {
                        el: pagination,
                        clickable: true,
                    },
                    breakpoints: {
                        1024: {
                            spaceBetween: 10,
                            slidesPerView: 3,
                        },
                    },
                });
            }
        }
        customElements.define("index-image-swiper", IndexImageSwiper);
    }
});
